export enum CookieKeys {
  LANGUAGE = '_language',
  SET_IDP_LANGUAGE = '_setIdpLanguage',
  COOKIE_CONSENT = 'cookie-consent',
  MARKETING = 'marketing',
  BRUTTOP_RICES ='_bruttoPrices'
}
